import { render, staticRenderFns } from "./area-conocimiento.vue?vue&type=template&id=71e88065&"
import script from "./area-conocimiento.component.ts?vue&type=script&lang=ts&"
export * from "./area-conocimiento.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports